import { render } from "./BaseLoading.vue?vue&type=template&id=619b9984"
import script from "./BaseLoading.vue?vue&type=script&lang=js"
export * from "./BaseLoading.vue?vue&type=script&lang=js"

import "./BaseLoading.vue?vue&type=style&index=0&id=619b9984&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__